/**
 * Safe user-list Excel columns — no passwords, addresses, or other sensitive fields.
 * Pass `t` so headers/status follow Header UI language.
 */

export function getUserListExportColumns(t) {
    return [
        {
            header: t('exports.name', { defaultValue: 'Name' }),
            key: '_name',
            render: (_, row) => [row.firstName, row.middleName, row.lastName].filter(Boolean).join(' '),
            width: 28,
        },
        {
            header: t('exports.username', { defaultValue: 'Username' }),
            key: 'username',
            render: (v, row) => v || row.userName || '',
            width: 18,
        },
        { header: t('exports.email', { defaultValue: 'Email' }), key: 'email', width: 28 },
        {
            header: t('exports.phone', { defaultValue: 'Phone' }),
            key: 'phoneNumber',
            render: (v, row) => v || row.phone || '',
            width: 16,
        },
        {
            header: t('exports.status', { defaultValue: 'Status' }),
            key: 'active',
            render: (v) => (v === false
                ? t('common.archived', { defaultValue: 'Archived' })
                : t('common.active', { defaultValue: 'Active' })),
            width: 10,
        },
    ];
}

export function getUserListWithRolesExportColumns(t) {
    return [
        ...getUserListExportColumns(t),
        {
            header: t('exports.roles', { defaultValue: 'Roles' }),
            key: 'roles',
            render: (v) => (Array.isArray(v) ? v.join(', ') : v || ''),
            width: 18,
        },
    ];
}
